const plansStaticData = [
  {
    planName: 'MAHABAHUBALI PLAN',
    planName1: 'MAHABAHUBALI PLAN 1 MONTH',
    planName2: 'MAHABAHUBALI PLAN 2 MONTHS',
    planName3: 'MAHABAHUBALI PLAN 3 MONTHS',
    imgAlt: 'MAHABAHUBALI PLAN',
    launchDate: '24/5/2022',
    accuracy: '82.93',
    callsPerMonth: 'Upto 12 Calls',
    lastMonthROI: '24.54',
    forecastROI: '62.64',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'Inside the Mahabahubali plan, those calls are included which are derived on the basis of deep research and high conviction, these are trend based calls. This plan is for those people who trade in high quantity with higher holding capacity, who do not panic when the market becomes volatile and stay positioned in the direction of the trend, based on their capacity. The objective behind placing such calls in this plan is to make huge profits. All calls under this plan are a kind of research-based predictions; do not consider them completely accurate. Segments covered in this plan are – NSE Cash and F&O, MCX, and Currency.',
    youtube: 'https://www.youtube.com/embed/WPfC-0gSX8Y',
    keyHighlights: [
      {
        title: 'Calls with Deep research and High Conviction',
        link: '',
        keyHighlightsImg: '../images/MAHABAHUBALI/keyHighlights-1.webp',
        imgAlt: 'Deep research and High Conviction',
      },
      {
        title: 'High Accuracy Trend-Based Calls',
        link: '',
        keyHighlightsImg: '../images/MAHABAHUBALI/keyHighlights-2.webp',
        imgAlt: 'High Accuracy',
      },
      {
        title: 'Upto 12 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '12 Calls in a Month',
      },
    ],
    metaTitle: 'MahaBhahubali Plan for Conquering the Stock Market',
    metaDescription:
      'MahaBhahubali Plan for the stock market. Build a personalized plan to conquer the market with confidence and skill.',
  },
  {
    planName: 'BRAHMASTRA PLAN',
    planName1: 'BRAHMASTRA PLAN 1 MONTH',
    planName2: 'BRAHMASTRA PLAN 2 MONTHS',
    planName3: 'BRAHMASTRA PLAN 3 MONTHS',
    imgAlt: 'BRAHMASTRA PLAN',
    launchDate: '17/11/2021',
    accuracy: '62.27',
    callsPerMonth: '10 to 14 Calls',
    lastMonthROI: '37.83',
    forecastROI: '96.24',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'Brahmastra plan includes the calls which are generated keeping in mind all the parameters of analysis and based on the system which has been developed after long back testing. This increases the chances of them being accurate. That is why they have been kept in the high accuracy category. The risk reward ratio is also kept more favorable in these calls. But even after this, they cannot be called risk free. Because risk in the market can be reduced, not eliminated. NSE Cash and F&O, MCX and Currency.',
    youtube: 'https://www.youtube.com/embed/x6Cd_D57VD8',
    keyHighlights: [
      {
        title: 'High Accuracy Calls for Big Profit.',
        link: '',
        keyHighlightsImg: '../../images/Brahmastra/keyHighlights-1.webp',
        imgAlt: 'Calls for Big Profit',
      },
      {
        title: 'High-Risk Reward Ratio',
        link: '',
        keyHighlightsImg: '../images/Brahmastra/keyHighlights-2.webp',
        imgAlt: 'High-Risk Reward Ratio',
      },
      {
        title: 'Upto 10 to 14 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 14 Calls in a Month',
      },
    ],
    metaTitle: 'Unleashing Market Power with Bramhastra Plan',
    metaDescription:
      'Bramhastra Plan for the stock market are designed to empower investors with a powerful strategy that harnesses advanced tools and data analytics to maximize returns.',
  },
  {
    planName: 'COMBO OF EVERYTHING (COE)',
    planName1: 'COMBO OF EVERYTHING (COE) 1 MONTH',
    planName2: 'COMBO OF EVERYTHING (COE) 2 MONTHS',
    planName3: 'COMBO OF EVERYTHING (COE) 3 MONTHS',
    imgAlt: 'COMBO OF EVERYTHING (COE)',
    launchDate: '7/10/2021',
    accuracy: '62.66',
    callsPerMonth: '10 to 20 Calls',
    lastMonthROI: '16.40',
    forecastROI: '101.49',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'The Combo of Everything plan has been designed keeping in mind the objective of diversifying trading. In this, you get all the plans in which all aspects of research have been taken into account. This plan is comprised of Mahabahubali plan, Brahmastra plan, Stock of the Month and BTST & STBT, NSE CASH Normal, MCX Normal, NSE F&O Normal, Currency.',
    youtube: null,
    keyHighlights: [
      {
        title:
          'Diversifying trading which also Includes Brahmastra & Mahabahubali Plan',
        link: '',
        keyHighlightsImg: '../images/ComboOfEverything/keyHighlights-1.webp',
        imgAlt: 'Diversifying trading',
      },
      {
        title: 'Entire Intelisys Research Calls under One plan.',
        link: '',
        keyHighlightsImg: '../images/ComboOfEverything/keyHighlights-2.webp',
        imgAlt: 'Research Calls under One plan',
      },
      {
        title: 'Upto 10 to 20 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 20 Calls in a Month',
      },
    ],
    metaTitle:
      'Combo Of Everything (COE) Your Complete Solution For Everything',
    metaDescription:
      'Combo Of Everything (COE) The Comprehensive Combo for traders for Stock Market Success with Advanced Tools, Expert Insights, and Personalized Support',
  },
  {
    planName: 'BTST STBT',
    planName1: 'BTST STBT 1 MONTH',
    planName2: 'BTST STBT 2 MONTHS',
    planName3: 'BTST STBT 3 MONTHS',
    title: 'BTST STBT Calls Provider',
    aboutContent:
      'Expert BTST STBT Tips for Successful Trading - Get Accurate Forecasts from a Reliable Provider',
    serviceContent:
      'Stay Ahead of the Game with Accurate BTST STBT Tips from a Reliable Provider',
    imgAlt: 'BTST STBT Calls Provider',
    launchDate: '22/11/2021',
    accuracy: '51.26',
    callsPerMonth: 'Upto 10 Calls',
    lastMonthROI: '37.77',
    forecastROI: '457.21',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'BTST STBT Calls Provider plan includes calls related to NSE F&O, currency and commodities, which are based on the concept of buy-today/sell-tomorrow and sell-today/buy-tomorrow.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Buy Today and Sell Tomorrow Calls (BTST)',
        link: '',
        keyHighlightsImg: '../images/BTSTSTBT/keyHighlights-1.webp',
        imgAlt: 'BTST STBT Calls Provider',
      },
      {
        title: 'Sell Today and Buy Tomorrow Calls (STBT)',
        link: '',
        keyHighlightsImg: '../images/BTSTSTBT/keyHighlights-2.webp',
        imgAlt: 'BTST STBT Tips',
      },
      {
        title: 'Upto 10 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'BTST STBT Strategy',
      },
    ],
    metaTitle: 'Best BTST STBT Tips From Leading BTST STBT Calls Provider',
    metaDescription:
      'Intelisys is the best BTST STBT Calls Provider, offers accurate and timely recommendations to assist you in making profitable trades with BTST STBT Tips.',
  },
  {
    planName: 'STOCK OF THE MONTH',
    planName1: 'STOCK OF THE MONTH 1 MONTH',
    planName2: 'STOCK OF THE MONTH 2 MONTHS',
    planName3: 'STOCK OF THE MONTH 3 MONTHS',
    title: 'Stock Of The Month',
    aboutContent:
      'Find the best Stock Market Prediction for Profitable Trading',
    serviceContent:
      'Best Stock Market Prediction to Help You Navigate the Indian Stock Market and Achieve Financial Success',
    imgAlt: 'Stock Of The Month',
    launchDate: '22/10/2019',
    accuracy: '56.50',
    callsPerMonth: 'Upto 2 Calls',
    lastMonthROI: '0.83',
    forecastROI: '28.26',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'Stock Of The Month plan we recommend to pick those stocks which fit the setup developed by us. All aspects of research are included in this setup so that the probability of the prediction being correct can be maximized. Segment covered in this plan is NSE Cash.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Stock which fits all Fundamental and technical parameters.',
        link: '',
        keyHighlightsImg: '../images/BTSTSTBT/keyHighlights-1.webp',
        imgAlt: 'Stock Of The Month',
      },
      {
        title: 'Covered NSE segment for Stocks.',
        link: '',
        keyHighlightsImg: '../images/BTSTSTBT/keyHighlights-2.webp',
        imgAlt: 'Stock Market Prediction',
      },
      {
        title: 'Upto 2 Calls in a Month.',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Stock Prediction',
      },
    ],
    metaTitle: 'Stock Of The Month | Stock Market Prediction',
    metaDescription:
      'Intelisys provides you the best Stock Of The Month and Stock Market Prediction to maximise your profits. Speak to our financial experts now.',
  },
  {
    planName: 'RAMBAAN PLAN',
    planName1: 'RAMBAAN PLAN 1 MONTH',
    planName2: 'RAMBAAN PLAN 2 MONTHS',
    planName3: 'RAMBAAN PLAN 3 MONTHS',
    imgAlt: 'RAMBAAN PLAN',
    launchDate: '21/4/2020',
    accuracy: '65',
    callsPerMonth: '20 to 30 calls',
    lastMonthROI: '69.22',
    forecastROI: '862.58',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: true,
    description:
      'Under this plan all the normal plans have been put together so that small traders can earn more profit with diversification, also it has been kept intact without tampering with accuracy, giving priority to their interests, and the fees have also been kept less as compared to taking different plans so that more and more people can take advantage of it. This plan is comprised of : NSE Cash and F&O normal/general plan, MCX Normal plan.',
    youtube: 'https://www.youtube.com/embed/3GUb_UealVo',
    keyHighlights: [
      {
        title: 'Plan Includes MCX, NSE CASH and F&O.',
        link: '',
        keyHighlightsImg: '../images/Rambaan/keyHighlights-1.webp',
        imgAlt: 'Plan Includes MCX, NSE CASH and F&O',
      },
      {
        title: 'High profitable calls with small stop losses.',
        link: '',
        keyHighlightsImg: '../images/Rambaan/keyHighlights-2.webp',
        imgAlt: 'calls with small stop losses',
      },
      {
        title: 'Upto 10 to 15 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 15 calls in a Month',
      },
    ],
    metaTitle: 'Rise to the Top with Rambaan Plan',
    metaDescription:
      'The Rambaan Plan for the Stock Market Empowers Investors to Build a Resilient Portfolio and Achieve Consistent Gains',
  },
  {
    planName: 'COMBO',
    planName1: 'COMBO 1 MONTH',
    planName2: 'COMBO 2 MONTHS',
    planName3: 'COMBO 3 MONTHS',
    imgAlt: 'COMBO',
    launchDate: '22/10/2019',
    accuracy: '57.88',
    callsPerMonth: 'Upto 10 to 14 Calls in a Month',
    lastMonthROI: '9.55',
    forecastROI: '261.00',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'COMBO plan where NSE Cash, NFO, Currency & MCX are all the normal plans added to make your trading diversified into all segments to generate consistent and appropriate profits. It is more suited for those who trade with a good amount and who want to work with moderate targets for high profits.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction of All Segments.',
        link: '',
        keyHighlightsImg: '../images/Combo/keyHighlights-1.webp',
        imgAlt: 'Prediction of All Segments',
      },
      {
        title: 'Upto 18 to 30 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '18 to 30 calls in a Month',
      },
    ],
    metaTitle: 'Power Up Your Portfolio With Combo (All Segment) Plan',
    metaDescription:
      'Combo (All Segment) Plan Offers a Comprehensive Strategy for Consistent Stock Market Success and Growth',
  },
  {
    planName: 'COMBO 1 PLAN',
    planName1: 'COMBO 1 PLAN 1 MONTH',
    planName2: 'COMBO 1 PLAN 2 MONTHS',
    planName3: 'COMBO 1 PLAN 3 MONTHS',
    imgAlt: 'COMBO 1 PLAN',
    launchDate: '22/11/2021',
    accuracy: '56.68',
    callsPerMonth: '10 to 18 calls',
    lastMonthROI: '25.48',
    forecastROI: '193.90',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is a plan where Brahmastra plan, BTST/STBT plan, stock of the month plan have been added to all the normal plans to make trading more diversified and more profitable. It is more suited for those who trade with large amounts and who want to work with both small and large targets.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Plan Includes Brahmastra, BTST/ STBT and Stock of the Month',
        link: '',
        keyHighlightsImg: '../images/Combo-1/keyHighlights-1.webp',
        imgAlt: 'Plan Includes Brahmastra, BTST/ STBT and Stock of the Month',
      },
      {
        title: 'Best suited for Traders.',
        link: '',
        keyHighlightsImg: '../images/Combo-1/keyHighlights-2.webp',
        imgAlt: 'Best suited for Traders',
      },
      {
        title: 'Upto 10 to 18 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 18 calls in a Month',
      },
    ],
    metaTitle: 'Combo 1 for Stock Market Success',
    metaDescription:
      'The Market Mastery Combo 1 - A Comprehensive Solution for Achieving Your Investment Goals in the Stock Market',
  },
  {
    planName: 'COMBO 2 PLAN',
    planName1: 'COMBO 2 PLAN 1 MONTH',
    planName2: 'COMBO 2 PLAN 2 MONTHS',
    planName3: 'COMBO 2 PLAN 3 MONTHS',
    imgAlt: 'COMBO 2 PLAN',
    launchDate: '22/11/2021',
    accuracy: '63.56',
    callsPerMonth: '8 to 14 calls',
    lastMonthROI: '21.05',
    forecastROI: '182.70',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is a plan where MAHABAHUBALI plan BTST/STBT plan, stock of the month plan have been added to all the normal plans to make trading more diversified and more profitable. It is more suited for those who trade with large amounts and who want to work with both small and large targets',
    youtube: null,
    keyHighlights: [
      {
        title: 'Plan Includes Mahabahubali, BTST/ STBT and Stock of the Month',
        link: '',
        keyHighlightsImg: '../images/Combo-2/keyHighlights-1.webp',
        imgAlt: 'Plan Includes Mahabahubali, BTST/ STBT and Stock of the Month',
      },
      {
        title: 'Wide range of trading opportunities.',
        link: '',
        keyHighlightsImg: '../images/Combo-2/keyHighlights-2.webp',
        imgAlt: 'trading opportunities',
      },
      {
        title: 'Upto 8 to 14 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '8 to 14 calls in a Month',
      },
    ],
    metaTitle: 'Combo 2 Your Path to Trading Success',
    metaDescription:
      'The Ultimate Combo 2 Solution for Investors Seeking to Maximize Their Returns and Minimize Their Risks',
  },
  {
    planName: 'MCX',
    planName1: 'MCX 1 MONTH',
    planName2: 'MCX 2 MONTHS',
    planName3: 'MCX 3 MONTHS',
    title: 'MCX Commodity Advisory',
    aboutContent:
      'Find the Best Genuine Commodity Tips Provider for Profitable Trading',
    serviceContent:
      'Maximize Your Returns with a Genuine Commodity Tips Provider - Expert Recommendations',
    imgAlt: 'MCX Commodity Advisory',
    launchDate: '22/11/2019',
    accuracy: '67.85',
    callsPerMonth: '10 to 22 calls',
    lastMonthROI: '57.48',
    forecastROI: '681.65',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Commodity Advisory Normal Plan is the plan which has been designed keeping in mind the small traders (those who trade with less capital). The calls given in this plan have also been analyzed keeping in mind all the aspects of research, keeping in mind the interests of the traders, no compromise has been made with the research. So that you can make good profit. The commodities covered under this plan are CRUDE OIL, NATURAL GAS, GOLD, SILVER, COPPER AND ZINC.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Specially designed for Small traders',
        link: '',
        keyHighlightsImg: '../images/MCX/keyHighlights-1.webp',
        imgAlt: 'MCX Commodity Advisory',
      },
      {
        title: 'Highly Profitable Calls.',
        link: '',
        keyHighlightsImg: '../images/MCX/keyHighlights-2.webp',
        imgAlt: 'Genuine Commodity Tips Provider',
      },
      {
        title: 'Upto 10 to 22 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'MCX advisory services',
      },
    ],
    metaTitle: 'MCX Commodity Advisory And Genuine Commodity Tips Provider',
    metaDescription:
      'We are Genuine Commodity Tips Provider. Intelisys MCX Commodity Advisory has a proven track record of 1500+ clients, Since 2006.',
  },
  {
    planName: 'NSE CASH',
    planName1: 'NSE CASH 1 MONTH',
    planName2: 'NSE CASH 2 MONTHS',
    planName3: 'NSE CASH 3 MONTHS',
    title: 'NSE Cash Advisory',
    aboutContent:
      'The NSE Cash Tips helps you to Maximize Your Investment Returns.',
    serviceContent:
      'Unlock the full potential of your investments with the help of NSE Cash Tips in the market',
    imgAlt: 'NSE Cash Advisory',
    launchDate: '22/10/2019',
    accuracy: '56.50',
    callsPerMonth: 'Upto 20+ calls get activated',
    lastMonthROI: '1.65',
    forecastROI: '56.52',
    returnType: 'Average',
    volatility: 'Low',
    specialPlan: false,
    description:
      'NSE Cash Advisory Normal Plan is the plan which has been designed keeping in mind the small traders (those who trade with less capital). The calls given in this plan have also been analyzed keeping in mind all the aspects of research, and keeping in mind the interests of the traders; no compromise has been made with the research. So that you can make good profit. We provide 4 to 5 stocks daily in this plan. The stocks included under this plan are not of any fixed nature, they are changed depending on the market situation.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Daily 4-5 Stocks Call.',
        link: '',
        keyHighlightsImg: '../images/NSECASH/keyHighlights-1.webp',
        imgAlt: 'NSE Cash Advisory',
      },
      {
        title: 'Low Risk with Good Profitable Calls',
        link: '',
        keyHighlightsImg: '../images/NSECASH/keyHighlights-2.webp',
        imgAlt: 'NSE Cash Tips',
      },
      {
        title: 'Upto 20+ calls get activated in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'NSE Cash forecast',
      },
    ],
    metaTitle: 'Best NSE Cash Advisory And NSE Cash Tips Provider In India',
    metaDescription: `Intelisys is India's Best NSE Cash Advisory Comapny. Intelisys offers well researched NSE Cash Tips to earn great profit from Indian stock market.`,
  },
  {
    planName: 'NSE FandO',
    planName1: 'NSE FandO 1 MONTH',
    planName2: 'NSE FandO 2 MONTHS',
    planName3: 'NSE FandO 3 MONTHS',
    title: 'NSE F&O Advisory',
    aboutContent:
      'Maximize Your Returns with Expert NSE Investment Advice from the Best F&O Tips Provider',
    serviceContent:
      'Get the Inside Scoop on NSE Investing from the Trusted Best F&O Tips Provider',
    imgAlt: 'NSE F&O Advisory',
    launchDate: '19/8/2020',
    accuracy: '58.54',
    callsPerMonth: '6 calls',
    lastMonthROI: '-',
    forecastROI: '135.72',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'NSE F&O plan is the plan which has been designed keeping in mind the small traders (those who trade with less capital). The calls given in this plan have also been analyzed keeping in mind all the aspects of research, and keeping in mind the interests of the traders; no compromise has been made with the research. So that you can make very good profit. The derivative stocks included under this plan are not of any fixed nature, they can be change changed according to the market condition.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Especially for Derivative Traders',
        link: '',
        keyHighlightsImg: '../images/NSEF&O/keyHighlights-1.webp',
        imgAlt: 'NSE F&O Advisory',
      },
      {
        title: 'Upto 6 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Best F&O Tips Provider',
      },
    ],
    metaTitle: 'Best NSE F&O Advisory From The Best F&O Tips Provider',
    metaDescription:
      'Intelisys provides the best NSE F&O Advisory and is the Best F&O Tips Provider in Indian stock market with valuable tips given from our team of analysts.',
  },
  {
    planName: 'CURRENCY',
    planName1: 'CURRENCY 1 MONTH',
    planName2: 'CURRENCY 2 MONTHS',
    planName3: 'CURRENCY 3 MONTHS',
    title: 'Currency Trading Advisory',
    aboutContent:
      'Expert Currency Tips for Successful Trading - Get Accurate Forecasts from a Reliable Provider',
    serviceContent:
      'Stay Ahead of the Game with Accurate Currency Tips from a Reliable Provider',
    imgAlt: 'Currency Trading Advisory',
    launchDate: '21/4/2020',
    accuracy: '55.26',
    callsPerMonth: '4 to 6 calls',
    lastMonthROI: '12.93',
    forecastROI: '76.44',
    returnType: 'Average',
    volatility: 'Low',
    specialPlan: false,
    description:
      'Currency Trading Advisory Normal Plan is the plan which has been designed keeping in mind the small traders (those who trade with less capital). The calls given in this plan have also been analyzed keeping in mind all the aspects of research, keeping in mind the interests of the traders, no compromise has been made with the research. So that you can make good profit. The currency derivatives covered under this plan are. USDINR, EURINR, JPYINR, GBPINR',
    youtube: null,
    keyHighlights: [
      {
        title: 'Especially for Currency Traders',
        link: '',
        keyHighlightsImg: '../images/CURRENCY/keyHighlights-1.webp',
        imgAlt: 'Currency Trading Advisory',
      },
      {
        title: 'Upto 4 to 6 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Currency Tips',
      },
    ],
    metaTitle: 'Best Currency Trading Advisory and Currency Tips Provider',
    metaDescription:
      'Maximize your profits with top Currency Trading Advisory company. Our team of financial experts can provide you with the most accurate and profitable Currency Tips.',
  },
  {
    planName: 'NIFTY AND BANKNIFTY',
    planName1: 'NIFTY AND BANKNIFTY 1 MONTH',
    planName2: 'NIFTY AND BANKNIFTY 2 MONTHS',
    planName3: 'NIFTY AND BANKNIFTY 3 MONTHS',
    title: 'Nifty And Bank Nifty Tips',
    aboutContent: 'Find the best Future Trading Tips for Profitable Trading',
    serviceContent:
      'Best Future Trading Tips to Help You Navigate the Indian Stock Market and Achieve Financial Success',
    imgAlt: 'Nifty And Bank Nifty Tips',
    launchDate: '8/6/2020',
    accuracy: '68',
    callsPerMonth: '16 to 24 calls',
    lastMonthROI: '9.64',
    forecastROI: '120',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: true,
    description:
      'Nifty And Bank Nifty Tips plan is the plan which has been designed keeping in mind the small traders (those who trade with less capital). The calls given in this plan have also been analyzed keeping in mind all the aspects of research, and keeping in mind the interests of the traders. No compromise has been made with the research, So that you can make very good profit. Only NIFTY and BANKNIFTY are covered under this plan.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Plan for Small Traders.',
        link: '',
        keyHighlightsImg: '../images/NiftyBankNifty/keyHighlights-1.webp',
        imgAlt: 'Nifty And Bank Nifty Tips',
      },
      {
        title: 'Upto 4 to 6 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Future Trading Tips',
      },
    ],
    metaTitle: 'Get Best Nifty And Bank Nifty Tips To Boost Your Investment',
    metaDescription:
      'Our team of experts have a proven track record of providing top-quality Nifty And Bank Nifty Tips and Future Trading Tips to help you maximize your returns.',
  },
  {
    planName: 'CRUDE OIL',
    planName1: 'CRUDE OIL 1 MONTH',
    planName2: 'CRUDE OIL 2 MONTHS',
    planName3: 'CRUDE OIL 3 MONTHS',
    title: 'MCX Crude Oil Advisory',
    aboutContent: 'Find the Best Crude Oil Tips for Profitable Trading',
    serviceContent:
      'Maximize Your Returns with a Crude Oil Tips - Expert Recommendations',
    imgAlt: 'MCX Crude Oil Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    forecastROI: '-',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Crude Oil Advisory is a conventional source of energy. It is very important to meet the energy needs of any country. Crude oil is used by refining it in the form of petrol, diesel and industrial products etc. Due to its importance, it is in great demand in the world and plays a special role in running the economy of any country smoothly. Due to its importance, it is also a center of attraction among the traders who trade on MCX. If you are also one of those traders then this plan is for you in which we cover only crude oil so that you can trade in a focused way. This plan has been made for MCX Crude Oil futures prediction .In this plan, the future prediction of crude oil prices is done on the basis of deep analysis and high conviction so that the best crude oil prediction calls can be generated .The objective of this plan is to serve those people who trade in only one commodity or want to take service of the individual commodity. All calls under this plan are a kind of research-based predictions; do not consider them completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Crude Oil traders.',
        link: '',
        keyHighlightsImg: '../images/CrudeOil/keyHighlights-1.webp',
        imgAlt: 'MCX Crude Oil Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Crude Oil Tips',
      },
    ],
    metaTitle: 'Get MCX Crude Oil Advisory and Get Expert Crude Oil Tips',
    metaDescription:
      'Intelisys MCX Crude Oil Advisory offer reliable and accurate Crude Oil Tips to help you succeed in the commodity market.',
  },
  {
    planName: 'NATURAL GAS',
    planName1: 'NATURAL GAS 1 MONTH',
    planName2: 'NATURAL GAS 2 MONTHS',
    planName3: 'NATURAL GAS 3 MONTHS',
    title: 'Natural Gas Advisory',
    aboutContent: 'Find the Best Natural Gas Tips for Profitable Trading',
    serviceContent:
      'Maximize Your Returns with a Natural Gas Tips - Expert Recommendations',
    imgAlt: 'Natural Gas Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    forecastROI: '-',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'Natural Gas Advisory is one of the commodities traded in the energy segment on MCX. Like crude oil, it is also a conventional source of energy. Along with its use in the daily activities of the people, the demand of energy in some industries is also met by it. Almost all traders are familiar with it due to its abundant use in person daily life. This is why people like to trade in it. If you are also one of them and like to trade in Natural Gas then this plan is for you. This plan has been made for MCX Natural Gas futures prediction. In this plan, the future prediction of Natural Gas prices is done on the basis of deep analysis and high conviction so that the best Natural Gas prediction calls can be generated. The objective of this plan is to serve those people who trade in only one commodity or want to take service of individual commodity. All calls under this plan are a kind of research-based predictions; do not consider them completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Natural Gas traders.',
        link: '',
        keyHighlightsImg: '../images/NaturalGas/keyHighlights-1.webp',
        imgAlt: 'Natural Gas Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Natural Gas Tips',
      },
    ],
    metaTitle:
      'Get MCX Natural Gas Advisory from Our Natural Gas Tips Provider',
    metaDescription:
      'Intelisys is the best Natural Gas Advisory company in India and offers well researched Natural Gas Tips for investors to increase their profits.',
  },
  {
    planName: 'GOLD',
    planName1: 'GOLD 1 MONTH',
    planName2: 'GOLD 2 MONTHS',
    planName3: 'GOLD 3 MONTHS',
    title: 'MCX Gold Advisory',
    aboutContent:
      'Maximize Your Returns with Expert Gold Investment Advice from the Best Gold Tips Provider',
    serviceContent:
      'Get the Inside Scoop on Gold Investing from the Trusted Best Gold Tips Provider',
    imgAlt: 'MCX Gold Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    forecastROI: '-',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Gold Advisory is a valuable commodity. Trading in gold has been happening since ancient times. People accept gold as a safe commodity. If you also consider gold as a safe commodity and want to earn profit by trading this valuable commodity even without owning it and taking advantage of the fluctuations in its price so this plan is for you. This plan has been made for Mcx gold futures prediction .In this plan, the future prediction of gold prices is done on the basis of deep analysis and high conviction so that the best gold prediction calls can be generated .The objective of this plan is to serve those people who trade in only one commodity or want to take service of the individual commodity. All calls under this plan are a kind of research-based predictions; do not consider them completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Gold traders.',
        link: '',
        keyHighlightsImg: '../images/Gold/keyHighlights-1.webp',
        imgAlt: 'MCX Gold Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Gold Tips',
      },
    ],
    metaTitle: 'MCX Gold Advisory and Get Expert Gold Tips From Intelisys',
    metaDescription:
      'Intelisys Provides Expert MCX Gold Advisory and provides the best Gold Tips in the Indian MCX Market, Thanks to Our Team of Skilled Analysts.',
  },
  {
    planName: 'SILVER',
    planName1: 'SILVER 1 MONTH',
    planName2: 'SILVER 2 MONTHS',
    planName3: 'SILVER 3 MONTHS',
    title: 'MCX Silver Advisory',
    aboutContent:
      'Maximize Your Returns with Expert Silver Investment Advice from the Best Silver Tips Provider',
    serviceContent:
      'Get the Inside Scoop on Gold Investing from the Trusted Best Silver Tips Provider',
    imgAlt: 'MCX Silver Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    forecastROI: '-',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Silver Advisory is one of the three precious metals (Gold, Silver, and Platinum) that come under the category of bullion which is traded on MCX. It is also used for investment along with industrial use and jewelry making. Due to the high volatility and liquidity in its prices, it is a very popular commodity for trading on MCX. If you want to take advantage of the high price movement in its price and if you like to trade only in silver, then this plan is for you. This plan has been made for Mcx silver futures prediction. In this plan, the future prediction of silver prices is done on the basis of deep analysis and high conviction so that the best silver prediction calls can be generated. The objective of this plan is to serve those people who trade in only one commodity or want to take service of the individual commodity. All calls under this plan are a kind of research-based predictions. Do not consider them completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Silver traders.',
        link: '',
        keyHighlightsImg: '../images/Silver/keyHighlights-1.webp',
        imgAlt: 'MCX Silver Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Silver Tips Provider',
      },
    ],
    metaTitle:
      'Discover the Best MCX Silver Advisory from our Best Silver Tips Provider',
    metaDescription:
      'Intelisys provides the best MCX Silver Advisory and is the Best Silver Tips Provider in Indian commodity market with valuable tips given from our team of analysts.',
  },
  {
    planName: 'COPPER',
    planName1: 'COPPER 1 MONTH',
    planName2: 'COPPER 2 MONTHS',
    planName3: 'COPPER 3 MONTHS',
    title: 'MCX Copper Advisory',
    aboutContent: 'Find the Best Copper Tips for Profitable Trading',
    serviceContent:
      'Maximize Your Returns with a Copper Tips - Expert Recommendations',
    imgAlt: 'MCX Copper Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    returnType: 'High',
    forecastROI: '-',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Copper Advisory is a metal that comes under the category of base metals, it has an important role in our daily life. Copper is an important industrial metal due to its high ductility, electrical conductivity and transmission resistance etc. It is used in electrical wiring, plumbing, roofing, industrial machinery etc. Copper is the best electrical conductor as compared to other metals except some precious metals. It is widely traded because of its wide range of uses. If you also want to trade in it without keeping it in physical form, then Copper futures contract available on MCX can be a good option for you. If you are willing to trade in it and want predictions related to its price, then this plan is for you. This plan has been made for MCX Copper futures prediction .In this plan, the future prediction of Copper prices is done on the basis of deep analysis and high conviction so that the best Copper prediction calls can be generated .The objective of this plan is to serve those people who trade in only one commodity or want to take service of the individual commodity. All calls under this plan are a kind of research-based predictions. Do not consider them Completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Copper traders.',
        link: '',
        keyHighlightsImg: '../images/COPPER/keyHighlights-1.webp',
        imgAlt: 'MCX Copper Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Copper tips',
      },
    ],
    metaTitle:
      'Stay Ahead in Copper Market with Professional MCX Copper Advisory',
    metaDescription:
      'Get profitable Copper Tips from the Best MCX Copper Advisory Company. Our team of experts delivers accurate and timely recommendations to help you maximize your returns.',
  },
  {
    planName: 'ZINC',
    planName1: 'ZINC 1 MONTH',
    planName2: 'ZINC 2 MONTHS',
    planName3: 'ZINC 3 MONTHS',
    title: 'MCX Zinc Advisory',
    aboutContent:
      'Maximize Your Returns with Expert Zinc Investment Advice from the Best Zinc Tips Provider',
    serviceContent:
      'Get the Inside Scoop on Gold Investing from the Trusted Best Zinc Tips Provider',
    imgAlt: 'MCX Zinc Advisory',
    launchDate: '6/1/2023',
    accuracy: '-',
    callsPerMonth: '3 to 9 calls',
    lastMonthROI: '-',
    forecastROI: '-',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: false,
    description:
      'MCX Zinc Advisory is a hard commodity which is one of the commodities traded on MCX comes under the category of base metals. Due to its low volatility, it is more popular among traders who like to trade in less volatile commodities and want to trade safely. If you also think like this and want to trade in this commodity then this plan is for you. This plan has been made for MCX Zinc futures prediction. In this plan, the future prediction of Zinc prices is done on the basis of deep analysis and high conviction so that the best Zinc prediction calls can be generated. The objective of this plan is to serve those people who trade in only one commodity or want to take service of the individual commodity. All calls under this plan are a kind of research-based predictions. Do not consider them completely accurate.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction for Zinc traders.',
        link: '',
        keyHighlightsImg: '../images/ZINC/keyHighlights-1.webp',
        imgAlt: 'MCX Zinc Advisory',
      },
      {
        title: 'Upto 3 to 9 calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Zinc Tips',
      },
    ],
    metaTitle: 'Boost Your Trading with MCX Zinc Advisory and Zinc Tips',
    metaDescription:
      'Intelisys is the best MCX Zinc Advisory in India, providing reliable Zinc Tips and the highest level of accuracy and conviction to all our clients.',
  },
  {
    planName: 'MBR',
    planName1: 'MBR 1 MONTH',
    planName2: 'MBR 2 MONTHS',
    planName3: 'MBR 3 MONTHS',
    imgAlt: 'MAHABAHUBALI BRAMHASTRA RAMBAAN',
    launchDate: '06/01/2023',
    accuracy: '65.49',
    callsPerMonth: 'Upto 10 to 20 Calls',
    lastMonthROI: '45.70',
    forecastROI: '348.34',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is the plan which includes MAHABAHUBALI, BRAHMASTRA, RAMBAAN. Diversifying risk is an important aspect of financial planning. It involves spreading your investments across different asset classes or investment options to reduce the overall risk of your portfolio. It is important to note that diversification does not guarantee a profit or protect against losses, but it can help reduce overall risk in your portfolio. It is suitable for high risk appetite individuals. All calls under this plan are a sort of exploration-based forecasts; do not consider them completely accurate. This is suitable for hardcore traders who look for the best possible profitable calls.',
    youtube: null,
    keyHighlights: [
      {
        title: 'Prediction of Highly Rated Calls of All Segments',
        link: '',
        keyHighlightsImg: '../images/MBRPlan/MBRKH1.webp',
        imgAlt: 'Highly Rated Calls of All Segments',
      },
      {
        title:
          'High-accuracy calls with In-depth analysis and trend-based calls for big profits',
        link: '',
        keyHighlightsImg: '../images/MBRPlan/MBRKH2.webp',
        imgAlt: 'In-depth analysis and trend-based calls for big profits',
      },
      {
        title: 'Upto 10 to 20 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 20 Calls in a Month',
      },
    ],
    metaTitle:
      'Conquer the Market with Mahabahubali, Bramhastra, RamBaan (MBR) Plan',
    metaDescription:
      'Maximizing Your Potential: The Mahabahubali, Bramhastra, RamBaan (MBR) Plan for Comprehensive Stock Market Success with Advanced Strategies and Personalized Support',
  },
  {
    planName: 'MB',
    planName1: 'MB 1 MONTH',
    planName2: 'MB 2 MONTHS',
    planName3: 'MB 3 MONTHS',
    imgAlt: 'MAHABAHUBALI BRAMHASTRA',
    launchDate: '06/01/2023',
    accuracy: '72.60',
    callsPerMonth: 'Upto 10 to 20 Calls',
    lastMonthROI: '31.19',
    forecastROI: '79.44',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is the plan which includes MAHABAHUBALI, BRAHMASTRA. Under this plan with in-depth analysis and trend-based calls, it can surely help you to increase the accuracy of trading decisions, though it does not guarantee big profits. As mentioned earlier, making profitable trading also involves factors such as risk management, timing, and diversification. The in-depth analysis involves researching and analyzing various factors such as financial statements, industry trends, and economic conditions to make informed investment decisions. The trend-based analysis involves analyzing market trends, patterns, and historical data to predict future price movements. Factors such as unexpected events, market volatility, and changes in economic conditions can all impact the profitability of trading. This plan is suitable for high- risk takers.',
    youtube: null,
    keyHighlights: [
      {
        title:
          'Top-to-bottom examination and pattern-based calls for enormous profits',
        link: '',
        keyHighlightsImg: '../images/MBPlan/MBKH1.webp',
        imgAlt: 'pattern-based calls for enormous profits',
      },
      {
        title: 'High precision calls for extraordinary profits',
        link: '',
        keyHighlightsImg: '../images/MBPlan/MBKH2.webp',
        imgAlt: 'High precision calls for extraordinary profits',
      },
      {
        title: 'Upto 10 to 20 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 20 Calls in a Month',
      },
    ],
    metaTitle: 'Market Mastery Combo: Mahabahubali, Bramhastra (MB) Plan',
    metaDescription:
      'The Mahabahubali, Bramhastra (MB) Plan for Mastering the Stock Market with Advanced Tools and Expert Insights',
  },
  {
    planName: 'BR',
    planName1: 'BR 1 MONTH',
    planName2: 'BR 2 MONTHS',
    planName3: 'BR 3 MONTHS',
    imgAlt: 'BRAMHASTRA RAMBAAN',
    launchDate: '06/01/2023',
    accuracy: '56.77',
    callsPerMonth: 'Upto 10 to 20 Calls',
    lastMonthROI: '56.28',
    forecastROI: '491.20',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is the plan which BRAHMASTRA, RAMBAAN. While accuracy is important in making trading decisions, it is not the only factor that determines profits. Making profitable trades with a high risk-to-reward ratio is the key to success in achieving great returns from stock and commodity market. if the trading is not managed well or if the timing is not optimal then chances of losing in the market would be very high.It is also important to note that high accuracy does not guarantee big profits. In fact, sometimes taking risks and making trading decisions that are less accurate but have a higher potential return may result in bigger profits over the long term. This plan is reasonable for high-taker individuals.',
    youtube: null,
    keyHighlights: [
      {
        title: 'High accuracy calls for big profits',
        link: '',
        keyHighlightsImg: '../images/BRPlan/BRKH1.webp',
        imgAlt: 'High accuracy calls for big profits',
      },
      {
        title: 'High profitable calls for small stop losses and good targets',
        link: '',
        keyHighlightsImg: '../images/BRPlan/BRKH2.webp',
        imgAlt: 'small stop losses and good targets',
      },
      {
        title: 'Upto 10 to 20 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 20 Calls in a Month',
      },
    ],
    metaTitle: 'Bramhastra, RamBaan (BR) Plan for Stock Market Gains',
    metaDescription:
      'Maximizing Your Potential and Empower Your Stock Trading with the Unbeatable Combination of Bramhastra, RamBaan (BR) Plans',
  },
  {
    planName: 'MR',
    planName1: 'MR 1 MONTH',
    planName2: 'MR 2 MONTHS',
    planName3: 'MR 3 MONTHS',
    imgAlt: 'MAHABAHUBALI RAMBAAN',
    launchDate: '06/01/2023',
    accuracy: '67.10',
    callsPerMonth: 'Upto 10 to 20 Calls',
    lastMonthROI: '49.63',
    forecastROI: '474.40',
    returnType: 'Highest',
    volatility: 'High',
    specialPlan: false,
    description:
      'This is the plan which includes MAHABAHUBALI, RAMBAAN. It is true that in-depth analysis and trend-based calls can potentially lead to big profits. However, it is important to note that there is always a degree of risk involved in trading, and past performance is not necessarily indicative of future results. The in-depth analysis involves taking a comprehensive look at a company or asset, including its financial statements, market trends, competition, and other relevant factors takes into account for providing recommendations from our side.Trend-based calls, on the other hand, involve identifying and capitalizing on market trends. This can involve analyzing historical price data and looking for patterns and trends that can help predict future price movements. By identifying these trends and making strategic trades based on them, traders can potentially generate big profits',
    youtube: null,
    keyHighlights: [
      {
        title: 'Calls with Deep research and High Conviction',
        link: '',
        keyHighlightsImg: '../images/MRPlan/MRKH1.webp',
        imgAlt: 'Deep research and High Conviction',
      },
      {
        title: 'High Accuracy Trend-Based Calls',
        link: '',
        keyHighlightsImg: '../images/MRPlan/MRKH2.webp',
        imgAlt: 'Trend-Based Calls',
      },
      {
        title: 'Upto 10 to 20 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: '10 to 20 Calls in a Month',
      },
    ],
    metaTitle: 'Mahabahubali, RamBaan (MR) Plan for Stock Market',
    metaDescription:
      'The Mahabahubali, RamBaan (MR) Plan for Stock Market Success with Powerful Tools, Customizable Insights, and Personalized Support',
  },
  {
    planName: 'NIFTY AND BANKNIFTY OPTION',
    planName1: 'NIFTY AND BANKNIFTY OPTION 1 MONTH',
    planName2: 'NIFTY AND BANKNIFTY OPTION 2 MONTHS',
    planName3: 'NIFTY AND BANKNIFTY OPTION 3 MONTHS',
    title: 'Nifty And Bank Nifty Option Tips',
    aboutContent: 'Find the best Future Trading Tips for Profitable Trading',
    serviceContent:
      'High profitable Nifty & Bank Nifty Live Trades for Call Option and Put Option traders',
    imgAlt: 'Nifty And Bank Nifty Option Tips',
    launchDate: '19/8/2020',
    accuracy: '75',
    callsPerMonth: '14 to 25 calls',
    lastMonthROI: '8.12',
    forecastROI: '120',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: true,
    description:
      'Are you a small trader looking to maximize returns with limited risk exposure? Our Nifty Bank Nifty Option Plan is designed just for you. In this strategic offering, we focus on providing option buying live trades for call option buying & put option buying which contains limited risk exposure with unlimited profit capitalizing possibilities, empowering you to capitalize on market movements.',
    youtube: null,
    keyHighlights: [
      {
        title: 'CE & PE Option Buying Calls',
        link: '',
        keyHighlightsImg: '../images/NiftyBankNifty/keyHighlights-1.webp',
        imgAlt: 'Nifty And Bank Nifty Option Tips',
      },
      {
        title: 'Upto 14 to 25 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Future Trading Tips',
      },
      {
        title: 'Least Capital Required can start with Rs 10k',
        link: '',
        keyHighlightsImg: '../images/MBPlan/MBKH1.webp',
        imgAlt: 'Future Trading Tips',
      },
    ],
    metaTitle:
      'Get Best Nifty And Bank Nifty Option Tips To Boost Your Investment',
    metaDescription:
      'Our team of experts have a proven track record of providing top-quality Nifty And Bank Nifty Option Tips and Future Trading Tips to help you maximize your returns.',
  },
  {
    planName: 'CHANAKYA PLAN OFFER',
    planName1: 'CHANAKYA PLAN OFFER 1 MONTH',
    planName2: 'CHANAKYA PLAN OFFER 2 MONTHS',
    planName3: 'CHANAKYA PLAN OFFER 3 MONTHS',
    title: 'Chanakya Plan Tips',
    aboutContent: 'Find the best Future Trading Tips for Profitable Trading',
    serviceContent:
      'High profitable Live Trades for Stock Call Option and Stock Put Option traders.',
    imgAlt: 'Chanakya Plan Tips',
    launchDate: '1/10/2023',
    accuracy: '85',
    callsPerMonth: '20 to 30 calls',
    lastMonthROI: '16.24',
    forecastROI: '194',
    returnType: 'High',
    volatility: 'Medium',
    specialPlan: true,
    description:
      'Whether you are just starting out or a seasoned investor, our comprehensive range of solutions is crafted to help you reach your financial goals. Come join us and pave the way to your financial success.',
    youtube: null,
    keyHighlights: [
      {
        title: 'CE & PE Option Buying Calls',
        link: '',
        keyHighlightsImg: '../images/NiftyBankNifty/keyHighlights-1.webp',
        imgAlt: 'Chanakya Plan Tips',
      },
      {
        title: 'Upto 20 to 30 Calls in a Month',
        link: '',
        keyHighlightsImg: '../images/keyHighlightsCommon.webp',
        imgAlt: 'Future Trading Tips',
      },
      {
        title: 'Least Capital Required can start with Rs 10k',
        link: '',
        keyHighlightsImg: '../images/MBPlan/MBKH1.webp',
        imgAlt: 'Future Trading Tips',
      },
    ],
    metaTitle: 'Get Best Chanakya Plan Tips To Boost Your Investment',
    metaDescription:
      'Our team of experts have a proven track record of providing top-quality Chanakya Plan Tips and Future Trading Tips to help you maximize your returns.',
  },
];

export default plansStaticData;
